// extracted by mini-css-extract-plugin
export default {"collapseIcon":"styles_collapseIcon__Igip-","expandSvg":"styles_expandSvg__ZRm3e","collapseSvg":"styles_collapseSvg__GxGtM","showExpandSvg":"styles_showExpandSvg__UqX6O"};